module.exports = __webpack_public_path__ + "img/oncoming_police_car.e0af6798.gif";